import { Helper } from '../Helper';
export class MapDeleteHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'REMOVE');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'HASKEY');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'REMOVE');
        sb.emitHelper(node, options, sb.helpers.wrapBoolean);
    }
}

//# sourceMappingURL=MapDeleteHelper.js.map
